import { MotionConfig } from "framer-motion";
import { SiteProvider } from "@/context/SiteContext";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Introduction } from "@/components/Introduction";
import { Research } from "@/components/Research";
import { Institute } from "@/components/Institute";
import { Application } from "@/components/Application";
import { Leadership } from "@/components/Leadership";
import { Collaboration } from "@/components/Collaboration";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

function App() {
    return (
        <SiteProvider>
            <MotionConfig reducedMotion="user">
                <Header />
                <main id="main" tabIndex={-1} data-testid="main-content" className="outline-none">
                    <Hero />
                    <Introduction />
                    <Research />
                    <Institute />
                    <Application />
                    <Leadership />
                    <Collaboration />
                    <Contact />
                </main>
                <Footer />
            </MotionConfig>
        </SiteProvider>
    );
}

export default App;
